// extracted by mini-css-extract-plugin
module.exports = {"secondaryAction":"SecondaryAction_secondaryAction__3p31Z","title":"SecondaryAction_title__1HKLn","link":"SecondaryAction_link__2F_WM"};